import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import SidebarCom from './SidebarCom';
import Header from './Header';

export default function AdminLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  if (!isAuthenticated) {
  
    return <Navigate to="/login" />;
  }

  return ( 
    <div className="flex h-screen">
    <SidebarCom />
    <div className="flex flex-1 flex-column h-screen  w-screen w-2  ">
      <Header />
      <main className="flex-1 overflow-y-auto px-3">
        <Outlet />
      </main>
    </div>
  </div>
  
  );
}